import { apiClient as client } from './client';

export interface ExecutiveDashboard {
    mrr: number | null;
    arr: number | null;
    growthRate: number | null;
    churnRate: number | null;
    nrr: number | null;
    asOf: string | null;
    insufficientData: boolean;
}

export interface RevenueBreakdownEntry {
    month: string;
    new: number;
    expansion: number;
    contraction: number;
    churn: number;
    net: number;
    insufficientData: boolean;
}

export interface RetentionCohort {
    month: string;
    size: number;
    retained: Record<number, number>;
}

export interface UnitEconomics {
    economics: {
        cac: number | null;
        ltv: number | null;
        ltvCacRatio: number | null;
        arpu: number | null;
        inputs: {
            marketingSpendUsdPerMonth: number | null;
            newSignupsLast30Days: number;
            monthlyChurnSource: 'observed' | 'fallback' | null;
            asOf: string | null;
        };
    };
    funnel: {
        label: string;
        value: number | null;
        percent: number | null;
    }[];
}

export interface PlatformValueAllResponse {
    executive: ExecutiveDashboard;
    revenue: RevenueBreakdownEntry[];
    retention: RetentionCohort[];
    economics: UnitEconomics;
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
}

const platformValueApi = {
    getAll: () =>
        client.get<ApiResponse<PlatformValueAllResponse>>('/admin/platform-value/all').then(res => res.data.data),

    getDashboard: () =>
        client.get<ApiResponse<ExecutiveDashboard>>('/admin/platform-value/dashboard').then(res => res.data.data),

    getRevenueBreakdown: (months: number = 6) =>
        client.get<ApiResponse<RevenueBreakdownEntry[]>>('/admin/platform-value/revenue-breakdown', { params: { months } }).then(res => res.data.data),

    getRetention: () =>
        client.get<ApiResponse<RetentionCohort[]>>('/admin/platform-value/retention').then(res => res.data.data),

    getUnitEconomics: () =>
        client.get<ApiResponse<UnitEconomics>>('/admin/platform-value/unit-economics').then(res => res.data.data),
};

export default platformValueApi;
